import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import { IProps } from './SharingNewReject.types';

export const renderSharingNewReject = (data: IProps) => openPopupHelper({ popupName: popupNames.REJECT_DIALOG, data });
